export default "__VITE_ASSET__C3ZJHhbm__"